module.exports = __webpack_public_path__ + "static/paul-94e9e6db5db8365945736898a77bb5e0.png";